import React, {useState,useEffect, useRef } from 'react'
import NavItems from './NavItems'
import headerLogo from '../../assets/images/logo.png'
import headerLogoLight from '../../assets/images/logo-light.png'
import { gsap } from 'gsap/all';
export default function Header() {

  const [isMobile, setIsMobile] = useState(false);
  const mobileNav = useRef(null);  

  const tggleNav =(event)=>{  
    event.target.classList.toggle("open"); 
    if(isMobile){
      if(!event.target.classList.contains("open")){ 
        gsap.to(mobileNav.current, {
          height:0,
          duration:0.3,
          ease:"expo.easeIn"
        })
      }else{ 
        gsap.to(mobileNav.current, { 
          height:"auto",
          duration:0.3,
          ease:"expo.easeOut"
        })
      }
    }
  }

  useEffect(() => {
    const checkWinSize = ()=>{
      if(window.innerWidth < 991){
        setIsMobile(true);
      }else{
        setIsMobile(false);
      }
    }
    checkWinSize(); 
    window.addEventListener("resize", checkWinSize);

    return () => {
      window.removeEventListener("resize", checkWinSize);
    };
  }, [isMobile]);

  return (
    <header id='fixed-target' className="header-area" data-scroll-sticky data-scroll-target="#fixed-target">
        <div className="navbar"> 
            <div className="container">
                <a href="/" className="brand">
                  <img className="logo-light" src={headerLogoLight} alt="Logo" />
                  <img className="logo-dark" src={headerLogo} alt="Logo" />
                </a>
                <button onClick={tggleNav} className="hum-btn d-lg-none ms-auto hub-toggle">
                  <span className="svg-wrap">
                    <svg className="ham hamRotate ham4" viewBox="0 0 100 100" width="80">
                      <path className="line top" d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20" />
                      <path className="line middle" d="m 70,50 h -40" />
                      <path className="line bottom" d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20" />
                  </svg>
                </span>
                </button>
               {!isMobile ? <NavItems></NavItems> : ""}  
            </div> 
            {isMobile ? <div ref={mobileNav} className="mobile-nav"><NavItems></NavItems></div> : ""}  
        </div>
    </header>
  )
} 